<template>
    <div class="QuestionnaireSet">
        <a-card class="card" title="基本设置" :bordered="false">
            <BaseSet ref="BaseSet" @changeType="changeType"></BaseSet>
        </a-card>
        <a-card class="card" title="能力设置" :bordered="false" style="margin-top: 20px;" v-if="type == 'edit'">
            <AblitySet></AblitySet>
        </a-card>

    </div>
</template>

<script>

import BaseSet from "./components/BaseSet";
import AblitySet from "./components/AblitySet";
// import VersionsSet from "./components/VersionsSet";
import $Bus from "@/pages/projectImpl/js/eventBus"

export default {
    name: 'QuestionnaireSet',
    components: {BaseSet, AblitySet},
    data() {
        return {
            type:  this.$store.getters["content/getQuestionnaireInfo"]() ? 'edit' : 'add',
        }
    },
    mounted() {
        this.setTitle()
    },
    methods: {
        // 设置当前页面title
        setTitle() {
            const info = this.$store.getters["content/getQuestionnaireInfo"]();
            let arr = ["首页", "内容中心", {name: "问卷管理", path: info.fullPath || "/content/QuestionnaireManage"}, "问卷配置"];
            let tabName = "问卷配置"
            if (this.type == "edit") {
                let currentName = info.contentName;
                let versionName = info.versionName;
                tabName = `${currentName}${versionName ? ' - ' + versionName : ''} 配置`
            }else{
                tabName = "问卷配置"
            }
            console.log(tabName);
            $Bus.$emit("pageHeaderTitle", tabName);
            $Bus.$emit("updateTabName", {path: this.$route.path, name: tabName});
            $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
        // 接收子组件传参
        changeType(val) {
            this.type = val
            setTimeout(() => {
                this.setTitle()
            }, 100)
        },
    },
    beforeDestroy() {
        $Bus.$emit("pageHeaderTitle", false);
    }
}
</script>

<style scoped lang="less">
.QuestionnaireSet {
    width: 100%;
    height: 100%;
}
</style>
